module.exports = __webpack_public_path__ + "img/OLD_convergenze_logo.f4ae1ace.png";